import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const selectControl = "omponents__SelectV2__styles_ts-selectControl-s172h7la";
export const selectValueContainer = "omponents__SelectV2__styles_ts-selectValueContainer-s17npf5y";
export const selectOption = "omponents__SelectV2__styles_ts-selectOption-s1lcsao1";
export const dropdownIcon = "omponents__SelectV2__styles_ts-dropdownIcon-d1wksatx";
export const wrapper = "omponents__SelectV2__styles_ts-wrapper-w1svvt1l";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");